"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Modal = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _framerMotion = require("framer-motion");

var _Backdrop = require("./components/Backdrop");

var _Dialog = require("./components/Dialog");

var _Portal = require("./components/Portal");

var _Modal = require("./Modal.style");

var _useDisableBodyScroll = require("./hooks/useDisableBodyScroll");

var _core = require("@emotion/core");

const propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   A new element will be created with this given `id` and attached to the `body` element. And then, the modal component will be rendered inside it.
  */
  id: _propTypes.string,

  /**
   Checks if modal should be displayed.
  */
  open: _propTypes.bool,

  /**
   The display content of the modal.
  */
  children: _propTypes.node.isRequired,

  /**
   Function called when clicking on the close button or outside the modal.
  */
  onClose: _propTypes.func.isRequired,

  /**
   The z-index position modal layer.
   */
  zIndex: _propTypes.number
} : {};
const defaultProps = {
  id: 'modal-root',
  open: false
};

const Modal = ({
  id,
  open,
  zIndex,
  children,
  onClose,
  ...props
}) => {
  (0, _useDisableBodyScroll.useDisableBodyScroll)(open);
  return (0, _core.jsx)(_framerMotion.AnimatePresence, null, open && (0, _core.jsx)(_Portal.Portal, {
    id: id
  }, (0, _core.jsx)(_Modal.ModalWrapper, {
    zIndex: zIndex
  }, (0, _core.jsx)(_Backdrop.Backdrop, props, (0, _core.jsx)(_Dialog.Dialog, {
    onClose: onClose
  }, children)))));
};

exports.Modal = Modal;
process.env.NODE_ENV !== "production" ? Modal.propTypes = propTypes : void 0;
Modal.defaultProps = defaultProps;
Modal.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Modal",
  "props": {
    "id": {
      "defaultValue": {
        "value": "'modal-root'",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "A new element will be created with this given `id` and attached to the `body` element. And then, the modal component will be rendered inside it."
    },
    "open": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Checks if modal should be displayed."
    },
    "children": {
      "type": {
        "name": "node"
      },
      "required": true,
      "description": "The display content of the modal."
    },
    "onClose": {
      "type": {
        "name": "func"
      },
      "required": true,
      "description": "Function called when clicking on the close button or outside the modal."
    },
    "zIndex": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "The z-index position modal layer."
    }
  }
};